// @ts-nocheck
import React, { useEffect, useState } from "react";
import useAccount from "classes/Accounts/hooks/useAccount";
import ScrollTable, { AsyncScrollTable } from "components/ScrollTable/ScrollTable";
import genRequest from "includes/request";
import { t } from "i18next";
import { useQuery } from "react-query";

export default function EmployeSelector({ selectedsUsers, setSelectedsUsers }) {
	const { account } = useAccount();
	const [selectedsSites, setSelectedsSites] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedsFams, setSelectedsFams] = useState([]);
	const [selectedGroups, setSelectedGroups] = useState([]);
	const [users, setUsers] = useState([]);

	const getContactFiltered = async (page = 1, groups = []) => {
		setIsLoading(true);
		try {
			const result = await genRequest("employees/search", {
				companyId: account.companyId,
				pageNumber: page,
				searchedCategories: groups,
			}, "post");
			// the employee id is aliased once, as the results enter the selector
			return { ...result, results: result.results.map((e) => ({ ...e, employeeId: e.id })) };
		} catch (error) {
			console.error('Erreur lors de la récupération des contacts:', error);
			throw error;
		} finally {
			setIsLoading(false);
		}
	};


	useEffect(() => {
		setUsers([]);
		setSelectedsUsers([]);
		setCurrentPage(1);
		setTotalPages(1);
		if (selectedGroups.length > 0) {
			const fetchInitialData = async () => {
				try {
					const result = await getContactFiltered(1, selectedGroups.map(group => group.id));
					setUsers(result.results);
					setCurrentPage(1);
					setTotalPages(result.totalPages);
				} catch (error) {
					console.error('Erreur:', error);
				}
			};
			fetchInitialData();
		}
	}, [selectedGroups]);

	const handleGetNextItems = async () => {
		if (isLoading || currentPage >= totalPages) return;

		try {
			const nextPage = currentPage + 1;
			const result = await getContactFiltered(nextPage, selectedGroups.map(group => group.id));

			setUsers(prevUsers => [...prevUsers, ...result.results]);
			setCurrentPage(nextPage);
		} catch (error) {
			console.error('Erreur lors du chargement des éléments suivants:', error);
		}
	};

	// Calculer hasMore basé sur les données de pagination
	const hasMore = currentPage < totalPages && !isLoading;

	return (
		<div className="d-flex h-100">
			<AsyncScrollTable
				companyId={account.companyId}
				itemId={"id"}
				queryKey={["Sites", "SitesOfCompany", account.companyId]}
				queryFn={() => genRequest("sites/company/" + account.companyId)}
				checkbox={true}
				className="light-bg"
				selected={selectedsSites}
				setSelected={setSelectedsSites}
				cols={[
					{
						name: "name",
						title: t("User.SITE"),
						component: ({ item }) => (<div>{[item.name, item.town].filter(a => a).join(" - ")}</div>)
					}
				]}
				sortBy="name"
			/>
			<AsyncScrollTable
				companyId={account.companyId}
				itemId={"id"}
				queryKey={["Groups", "OfCompany", account.companyId]}
				queryFn={() => genRequest("groups/company/" + account.companyId)}
				checkbox={true}
				className="light-bg"
				selected={selectedGroups}
				setSelected={setSelectedGroups}
				cols={[
					{
						name: "groupName",
						title: t("User.GROUPS"),
						component: ({ item }) => (item.groupName !== " " && <div>{item.groupName}</div>)

					}
				]}
				sortBy="groupName"
			/>

			<ScrollTable
				cols={[
					{
						name: "firstName",
						title: t("User.USER"),
						component: ({ item }) => <div>{item.lastName} {item.firstName}</div>
					}

				]}
				selected={selectedsUsers}
				setSelected={setSelectedsUsers}
				className="light-bg"
				checkbox={true}
				itemId={"employeeId"}
				getNextItems={handleGetNextItems}
				hasMore={hasMore}
				items={users}
			/>
		</div>
	);
}
